import { useMutation, UseMutationOptions } from "@tanstack/react-query";
import { queryClient } from "App";
import axiosConfig from "axiosConfig";
import { TOAST_TYPES_ENUM } from "enums";
import { Toast } from "shared";

export const useResendRodo = (
  options?: UseMutationOptions<any, Error, string>, // string = UUID użytkownika
  withoutToast?: boolean
) => {
  return useMutation({
    mutationKey: ["userRodoResend"],
    mutationFn: async (uuid: string) => {
      return axiosConfig.post(`/users/rodo-resend/${uuid}`).then((res) => res.data);
    },
    onMutate: (uuid) => {
      if (!withoutToast) {
        Toast({
          message: "Wysyłanie klauzuli RODO...",
          type: TOAST_TYPES_ENUM.LOADING,
          id: "userRodoResend",
        });
      }
      if (options && options.onMutate) {
        return options.onMutate(uuid);
      }
    },
    onSuccess: (data, uuid, context) => {
      if (!withoutToast) {
        Toast({
          message: "Klauzula RODO została wysłana",
          type: TOAST_TYPES_ENUM.SUCCESS,
          id: "userRodoResend",
        });
      }
      // np. jeśli potrzebujesz odświeżyć dane użytkownika
      setTimeout(() => {
        queryClient.invalidateQueries({ queryKey: ["me"] });
      }, 100);

      if (options && options.onSuccess) {
        options.onSuccess(data, uuid, context);
      }
    },
    onError: (error, uuid, context) => {
      if (!withoutToast) {
        Toast({
          message: "Błąd podczas wysyłania klauzuli RODO",
          type: TOAST_TYPES_ENUM.ERROR,
          id: "userRodoResend",
        });
      }
      if (options && options.onError) {
        options.onError(error, uuid, context);
      }
    },
  });
};
